import http from '@services/http';
import { Profiles } from './interfaces';

export const fetchSyncState = (data: Profiles.Enrichment.FetchSyncState.Request): Promise<Profiles.Enrichment.FetchSyncState.Response> => {
  return http.get(`/profiles/${data.userId}/enrichment`);
};

export const populate = (data: Profiles.Enrichment.Populate.Request): Promise<Profiles.Enrichment.Populate.Response> => {
  return http.post(`/profiles/${data.userId}/enrichment`, data);
};